import { STATES } from '../../constants';

export function ForgotPasswordConfig($stateProvider) {
  'ngInject';
  return $stateProvider.state(STATES.FORGOT_PASSWORD, {
    url: '/forgot-password',
    views: {
      '@': {
        template: '<upd-forgot-password></upd-forgot-password>',
      },
    },
    scrollTop: true,
    analytics: {
      page: 'Forgot Password',
    },
    data: {
      permissions: '!signedIn',
    },
  });
}
